import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Empty } from "antd";

const StackedBarChart = ({ graphData, categoryKey }) => {
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState(
    graphData.map((item) => item[categoryKey]),
  );

  useEffect(() => {
    if (!graphData || graphData.length === 0) return;

    setCategories(graphData.map((item) => item[categoryKey]));
    const keys = Object.keys(graphData[0]).filter((key) => key !== categoryKey);

    const generatedSeries = keys.map((key) => ({
      name: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      data: graphData.map((item) => item[key] ?? 0),
    }));

    setSeries(generatedSeries);
  }, [graphData]);

  if (!graphData || graphData.length === 0) {
    return (
      <Empty
        style={{
          height: "300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        description={
          <span style={{ color: "#FB3748" }}>No data available</span>
        }
      />
    );
  }

  const options = {
    chart: {
      type: "bar",
      height: 300,
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 7,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "all",
      },
    },
    xaxis: {
      categories,
    },
    yaxis: {
      show: false,
    },
    colors: ["#1FC16B", "#FFBF00", "#FB3748"],
    legend: {
      position: "top",
      horizontalAlign: "right",
      markers: {
        width: 10,
        height: 10,
        radius: 10,
        shape: "circle",
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 7,
      colors: ["transparent"],
    },
    tooltip: {
      y: {
        formatter: (val, { seriesIndex }) => val,
      },
    },
  };

  return (
    <ReactApexChart options={options} series={series} type="bar" height={350} />
  );
};

export default StackedBarChart;
